import { render, staticRenderFns } from "./electiveResources.vue?vue&type=template&id=079c7b56&scoped=true"
import script from "./electiveResources.vue?vue&type=script&lang=js"
export * from "./electiveResources.vue?vue&type=script&lang=js"
import style0 from "./electiveResources.vue?vue&type=style&index=0&id=079c7b56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c7b56",
  null
  
)

export default component.exports